"use client";

import { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
// import SearchDrawer from "./SearchDrawer";

export default function StickyLogoBar({ show }) {
    const stickyRef = useRef(null);
    const [mounted, setMounted] = useState(false);
    // const [searchOpen, setSearchOpen] = useState(false);
    const [stickyHeight, setStickyHeight] = useState(52); // default sm:h

    // Mount flag to avoid hydration mismatch
    useEffect(() => {
        setMounted(true);
    }, []);

    // Update sticky height for SearchDrawer positioning
    useEffect(() => {
        const updateOffset = () => {
            if (!stickyRef.current) return;
            const rect = stickyRef.current.getBoundingClientRect();
            setStickyHeight(rect.height);
        };

        updateOffset();
        const observer = new ResizeObserver(updateOffset);
        observer.observe(stickyRef.current);
        window.addEventListener("scroll", updateOffset);
        window.addEventListener("resize", updateOffset);

        return () => {
            observer.disconnect();
            window.removeEventListener("scroll", updateOffset);
            window.removeEventListener("resize", updateOffset);
        };
    }, []);

    // Mobile swipe to open search
    // useEffect(() => {
    //     if (typeof window === "undefined" || window.innerWidth > 768) return;

    //     let swipeStartX = 0;

    //     const handleSwipeStart = (e) => {
    //         swipeStartX = e.touches[0].clientX;
    //     };

    //     const handleSwipeEnd = (e) => {
    //         const deltaX = e.changedTouches[0].clientX - swipeStartX;
    //         if (swipeStartX < 30 && deltaX > 60) {
    //             setSearchOpen(true);
    //         }
    //     };

    //     window.addEventListener("touchstart", handleSwipeStart);
    //     window.addEventListener("touchend", handleSwipeEnd);

    //     return () => {
    //         window.removeEventListener("touchstart", handleSwipeStart);
    //         window.removeEventListener("touchend", handleSwipeEnd);
    //     };
    // }, []);

    return (
        <div
            ref={stickyRef}
            className="sticky top-0 bg-white dark:bg-zinc-950 shadow-sm z-[1000] h-[44px] sm:h-[52px]"
        >
            <div className="flex items-center justify-between px-4 sm:px-6 lg:px-8 text-sm font-medium max-w-full mx-auto h-full">
                {/* LEFT: Actions placeholder */}
                <div className="flex items-center gap-4 min-w-[100px]">
                    {/* Future icons: search, notifications */}
                </div>

                {/* CENTER: Logo container - always rendered */}
                <motion.div
                    initial={false}
                    animate={{ opacity: mounted && show ? 1 : 0 }}
                    transition={{ duration: 0.3, ease: [0.33, 1, 0.68, 1] }}
                    className="no-copy text-2xl sm:text-3xl font-serif font-extrabold text-black dark:text-white tracking-tight"
                    style={{ width: 120, willChange: "opacity" }} // fixed width to reserve space
                    aria-hidden={!mounted || !show}
                >
                    MyBlog
                </motion.div>

                {/* RIGHT: Auth / Subscribe placeholder */}
                <div className="flex items-center gap-3 justify-end min-w-[100px]">
                    {/* Add Subscribe / Login in future */}
                </div>
            </div>

            {/* <SearchDrawer
                open={searchOpen}
                onClose={() => setSearchOpen(false)}
                stickyHeight={stickyHeight}
            /> */}
        </div>
    );
}
